/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
var propertyToMCSSstate_1 = require("./util/propertyToMCSSstate");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./Chip.css'); }
var IconButton_1 = require("./IconButton");
exports.chipSizeArray = ["small", "medium"];
exports.Chip = function Chip(_a) {
    var children = _a.children, className = _a.className, onDelete = _a.onDelete, size = _a.size;
    return (React.createElement("div", { className: classnames("m-chip", className, size && propertyToMCSSstate_1.propertyToMCSSstate("m-chip", size)) },
        children,
        React.createElement(IconButton_1.IconButton, { type: "close-small", onClick: onDelete })));
};
exports.Chip.propTypes = {
    onDelete: PropTypes.func.isRequired,
    size: PropTypes.oneOf(exports.chipSizeArray)
};
exports.Chip.defaultProps = {
    size: "small"
};